import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Error } from '../../../Data/error.dto';

import { EventType, UserCreatedEvents } from '../../../Data/event.dto';
import { EventReducer } from '../../Reducers/Dashboard/EventReducer';
import { Member } from '../../../Data/member.dto';

export interface EventSchedulingStats {
    total_events_scheduled: number;
    events_scheduled_this_month: number;
    events_scheduled_this_week: number;
    events_scheduled_today: number;
}

export interface EventState {
    loading: boolean;
    Events: EventType[];
    availableMembers: Member[] | []
    error: Error;
    isError: boolean;
    success: boolean;
    isEventUpdate: boolean;
    currentEvent?: EventType;
    userCreatedEvents?: UserCreatedEvents[];
    currentCreatedEvent?: UserCreatedEvents;
    eventNames: [];
    event_scheduling: EventSchedulingStats | null;
}

const initialState: EventState = {
    Events: [],
    isEventUpdate: true,
    loading: false,
    error: {},
    isError: false,
    success: false,
    availableMembers: [],
    eventNames: [],
    event_scheduling: null,
}



const eventSlice = createSlice({
    name: 'event',
    initialState,
    reducers: {
        clearError(state) {
            state.error = {};
            state.isError = false;
        },
        setCurrentEvent(state, action: PayloadAction<EventType>) {
            state.currentEvent = action.payload;
        },
        clearCurrentEvent(state) {
            delete state.currentEvent;
        },
        setUserCreatedEvent(state, action: PayloadAction<UserCreatedEvents>) {
            state.currentCreatedEvent = action.payload;
        },
        removeUserCreatedEvent(state) {
            delete state.currentCreatedEvent;
        },
        setAvailableMember(state, action: PayloadAction<Member[]>) {
            state.loading = false;
            state.availableMembers = action.payload;
        },

    },
    extraReducers: (builder) => {
        EventReducer(builder);
    },
});

export const { clearError, setCurrentEvent, clearCurrentEvent, setUserCreatedEvent, removeUserCreatedEvent, setAvailableMember } = eventSlice.actions;


export default eventSlice.reducer;
